/* eslint-disable no-unused-vars */
// customers page for the bulk water subscription
import {
  AddContainer,
  InnerModal,
  MainContainer,
  ModalAcceptButton,
  ModalCancelButton,
  TopBarContainedBrandButton,
  TopBarContainer,
} from "../constants/component.constants";
import Grid from "@mui/material/Grid";
import {
  Chip,
  Divider,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  formatCurrency,
  isEmptyObject,
  isEmptyString,
  isNullUndefined,
  isValidPhoneNumber,
} from "../util/util";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  Contacts,
  CreditCard,
  Edit,
  LocalAtm,
  NearMe,
  Visibility,
  Apartment,
  Person,
} from "@mui/icons-material";
import PersonOrgSearch from "../components/modals/personOrgSearch";
import AddNewUser from "../components/modals/addNewUser";
import AddNewOrganization from "../components/modals/addNewOrganization";
import {
  getCustomers,
  getFacilityCustomers,
  saveCustomer,
  saveFacilityCustomer,
  fetchCustomers,
} from "../services/customers.service";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";
import {
  getMeterBillingPeriods,
  saveMeterBillingPayment,
} from "../services/meterbilling.service";
import { getIdTypes, getMeterBillingDays } from "../services/list.service";
import { getUserRoles, saveUser } from "../services/users.service";
import ReceivePayment from "../components/modals/receivePayment";
import { printCustomerSalesStatement } from "../services/print.service";
import { issueResponseMessage, issueWarnMessage } from "../actions/message";
import Permit from "../util/permit";
import CreditNote from "../components/modals/creditNote";
import DebitNote from "../components/modals/debitNote";
import dayjs from "dayjs";
import MuiDataGrid from "../components/modules/MuiDataGrid";
import { useSelector } from "react-redux";
import CustomerView from "./customerView";
import EditUserModal from "../components/modules/users/editUserModal";
import { deepOrange, green } from "@mui/material/colors";

export default function Customers() {
  const user = useSelector((state) => state.auth.user);
  const [ViewDiv, setViewDiv] = useState(false);
  const [customerModal, setCustomerModal] = useState(false);
  const [PaymentModal, setPaymentModal] = useState(false);
  const [AddOrganizationModal, setAddOrganizationModal] = useState(false);
  const [AddUserModal, setAddUserModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [facilityClients, setFacilityClients] = useState([]);
  const [billingPeriods, setBillingPeriods] = useState([]);
  const [meterBillingDays, setMeterBillingDays] = useState([])
  const [idTypes, setIdTypes] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [statementYear, setStatementYear] = useState(new Date());
  const [task, setTask] = useState("");
  const [creditModal, setCreditModal] = useState(false);
  const [chargeModal, setChargeModal] = useState(false);
  const [voidItem, setVoidItem] = useState(null);
  const [companySearch, setCompanySearch] = useState("");
  const [editCompanyContactModal, setEditCompanyContactModal] = useState(false);
  const [selectedCompanyContact, setSelectedCompanyContact] = useState();
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    getMeterBillingPeriods().then((billingPeriods) =>
      setBillingPeriods(billingPeriods),
    );
    getMeterBillingDays().then((days) => setMeterBillingDays(days))
    getIdTypes().then((idTypes) => setIdTypes(idTypes));
    getUserRoles().then((userRoles) => setUserRoles(userRoles));
  }, []);

  useEffect(() => {
    if (
      !isNullUndefined(user.proxyFacility) &&
      !isEmptyString(user.proxyFacility)
    ) {
      setLoading(true);
      if (user.services.includes("MAINT")) {
        getFacilityCustomers()
          .then((rows) => setFacilityClients(rows || []))
          .catch(() => setFacilityClients([]))
          .finally(() => {
            setLoading(false);
          });
      } else {
        getCustomers()
          .then((rows) => setRows(rows || []))
          .catch(() => setRows([]))
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, [user.proxyFacility, user?.services]);

  const addCustomer = useCallback(
    (data) => {
      let sendData = {
        selectedCustomer: data,
      };
      return saveCustomer(sendData).then((response) => {
        issueResponseMessage(response);
        // A rejected save resolves to undefined (the service raises the error
        // toast). Leave the form open so the details can be corrected.
        if (isNullUndefined(response) || response.type === "error") {
          return response;
        }
        setLoading(true);
        if (user.services.includes("MAINT")) {
          getFacilityCustomers()
            .then((rows) => setFacilityClients(rows || []))
            .catch(() => setFacilityClients([]))
            .finally(() => {
              setLoading(false);
            });
        } else {
          getCustomers()
            .then((rows) => setRows(rows || []))
            .catch(() => setRows([]))
            .finally(() => {
              setLoading(false);
            });
        }
        setAddUserModal(false);
        setAddOrganizationModal(false);
        return response;
      });
    },
    [user.services],
  );

  const addFacilityCustomer = useCallback((data) => {
    let sendData = {
      selectedCustomer: data,
    };
    return saveFacilityCustomer(sendData).then((response) => {
      issueResponseMessage(response);
      // A rejected save resolves to undefined (the service raises the error
      // toast). Leave the form open so the details can be corrected.
      if (isNullUndefined(response) || response.type === "error") {
        return response;
      }
      setLoading(true);
      getFacilityCustomers()
        .then((rows) => setFacilityClients(rows || []))
        .catch(() => setFacilityClients([]))
        .finally(() => setLoading(false));
      setAddUserModal(false);
      setAddOrganizationModal(false);
      return response;
    });
  }, []);

  function savePayment(data) {
    data.meterBillingId = selectedCustomer.billingId;
      saveMeterBillingPayment(data).then((response) => {
      issueResponseMessage(response);
      if (!isNullUndefined(response)) {
        setPaymentModal(false);
        setLoading(true);
        if (user.services.includes("MAINT")) {
          getFacilityCustomers()
            .then((rows) => setFacilityClients(rows || []))
            .catch(() => setFacilityClients([]))
            .finally(() => {
              setLoading(false);
            });
        } else {
          getCustomers()
            .then((rows) => setRows(rows || []))
            .catch(() => setRows([]))
            .finally(() => {
              setLoading(false);
            });
        }
      }
    });
  }

  function handleViewClick(customer) {
    let customerId = "";
    if (customer.type === "Individual") {
      customerId = customer.id + "_P";
    } else {
      customerId = customer.id + "_O";
    }
    fetchCustomers(customerId).then((response) => {
      if (!isNullUndefined(response) && !isNullUndefined(response.id)) {
        setSelectedCustomer(response);
        setViewDiv(true);
      }
    });
  }

  function handleViewClient(customer) {
    setSelectedCustomer(customer);
    setViewDiv(true);
  }

  function handleEditClick(customer) {
    setTask("Edit");
    setSelectedCustomer(customer);
    if (customer.type === "Individual") {
      setAddUserModal(true);
    } else if (customer.type === "Company") {
      setAddOrganizationModal(true);
    }
  }

  function handleEditCompanyContactClicked(item) {
    setEditCompanyContactModal(true);
    setSelectedCompanyContact(item.contact);
    setTask("Edit");
  }

  function validateUserForm(sendData) {
    if (isNullUndefined(sendData)) {
      issueWarnMessage(
        "Could not find user data, please refresh the page and try again.",
      );
      return false;
    }
    if (isEmptyString(sendData.firstName) || isEmptyString(sendData.lastName)) {
      issueWarnMessage("First name and Last name are required.");
      return false;
    }
    if (
      isNullUndefined(sendData.mobilePhone) ||
      isEmptyString(sendData.mobilePhone)
    ) {
      issueWarnMessage("Mobile Phone number is required.");
      return false;
    }
    const { isValid, errors } = isValidPhoneNumber(sendData?.mobilePhone);
    if (!isValid) {
      issueWarnMessage(`Mobile phone number is invalid. ${errors.join(". ")}`);
      return false;
    }

    if (sendData?.officePhone) {
      if (sendData?.officePhone === sendData?.mobilePhone) {
        issueWarnMessage(
          `Office phone number cannot be same as mobile phone number. Leave blank if you don't have a separate phone number.`,
        );
        return false;
      }
      const { isValid, errors } = isValidPhoneNumber(sendData?.officePhone);
      if (!isValid) {
        issueWarnMessage(
          `Office phone number is invalid. ${errors.join(". ")}`,
        );
        return false;
      }
    }
    if (
      isNullUndefined(sendData.idNumber) ||
      isEmptyString(sendData.idNumber) ||
      isNullUndefined(sendData.idTypeCd) ||
      isEmptyString(sendData.idTypeCd)
    ) {
      issueWarnMessage("Must provide and ID number and ID type.");
      return false;
    }
    if (isNullUndefined(sendData.email) || isEmptyString(sendData.email)) {
      issueWarnMessage("Must provide an email.");
      return false;
    }

    return true;
  }

  function handleSaveCompanyContactClicked() {
    let params = selectedCompanyContact;
    if (validateUserForm(params)) {
      saveUser(params).then((response) => {
        issueResponseMessage(response);
        setLoading(true);
        if (user.services.includes("MAINT")) {
          getFacilityCustomers()
            .then((rows) => setFacilityClients(rows || []))
            .catch(() => setFacilityClients([]))
            .finally(() => {
              setLoading(false);
            });
        } else {
          getCustomers()
            .then((rows) => setRows(rows || []))
            .catch(() => setRows([]))
            .finally(() => {
              setLoading(false);
            });
        }
        setEditCompanyContactModal(false);
        setSelectedCompanyContact();
      });
    }
  }

  function handlePaymentClick(customer) {
    setSelectedCustomer(customer);
    setPaymentModal(true);
  }

  function handlePersonOrgSelect(result) {
    setSelectedCustomer(result);
    setTask("Add");
    if (result.type === "Individual") {
      setAddUserModal(true);
    } else {
      setAddOrganizationModal(true);
    }
    setCustomerModal(false);
  }

  function handleBillingPeriodChange(event) {
    let value = event.target.value;
    let obj = selectedCustomer;
    obj.billingPeriod = value;
    setSelectedCustomer(obj);
  }

  function handleIssueCharge(customer) {
    setChargeModal(true);
    setSelectedCustomer(customer);
  }

  function handleIssueCredit(customer) {
    setCreditModal(true);
    setSelectedCustomer(customer);
  }

  function handleNextBillingDateChange(value) {
    let date = new Date(value);
    let obj = selectedCustomer;
    obj.billingDate = date;
    setSelectedCustomer(obj);
  }

  function handleIdTypeChange(event) {
    let obj = selectedCustomer;
    obj.idTypeCd = event.target.value;
    setSelectedCustomer(obj);
  }

  function handleStatementYearChange(value) {
    let date = new Date(value);
    setStatementYear(date);
  }

  function handlePrintCustomerStatement() {
    printCustomerSalesStatement(
      selectedCustomer.billingId,
      statementYear.getFullYear(),
    );
  }

  function handleNewIndividual(idNoSearch, idTypeSearch) {
    setTask("Add");
    setSelectedCustomer((prevState) => ({
      ...prevState,
      type: "Individual",
      id: null,
      email: null,
      organization: null,
      idNumber: idNoSearch,
      idTypeCd: idTypeSearch,
    }));
    setCustomerModal(false);
    setAddUserModal(true);
  }

  function handleNewCompany(company) {
    setCompanySearch(company);
    setSelectedCustomer((prevState) => ({
      ...prevState,
      id: null,
      name: company,
      description: "",
      taxId: "",
      address: {
        id: "",
        address1: "",
        address2: "",
        countryCd: "",
        city: "",
      },
      contact: {
        id: "",
        firstName: "",
        middleName: "",
        lastName: "",
        mobilePhone: "",
        officePhone: "",
        email: "",
        credentialId: "",
        idNumber: "",
        idTypeCd: "",
      },
      absoluteCreditLimit: "",
      type: "Company",
    }));
    setCustomerModal(false);
    setAddOrganizationModal(true);
    setTask("Add");
  }

  function getChipProps(params) {
    if (!isNullUndefined(params.value)) {
      if (params.value === "Company") {
        return {
          icon: <Apartment style={{ fill: deepOrange[500] }} />,
          label: "Company",
          style: {
            borderColor: deepOrange[500],
          },
        };
      } else if (params.value === "Individual") {
        return {
          icon: <Person style={{ fill: green[500] }} />,
          label: "Individual",
          style: {
            borderColor: green[500],
          },
        };
      } else {
        return "N/A";
      }
    }
  }

  const columns = [
    {
      field: "name",
      headerName: "Account Holder",
      minWidth: 400,
      flex: 4,
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 150,
      flex: 2,
      renderCell: (params) => {
        return (
          <Chip variant="outlined" size="small" {...getChipProps(params)} />
        );
      },
    },
    {
      field: "billingBalance",
      headerName: "Account Balance",
      minWidth: 200,
      flex: 2,
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
    {
      field: "availableCreditLimit",
      headerName: "Available Credit Limit",
      minWidth: 200,
      flex: 2,
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
    {
      field: "absoluteCreditLimit",
      headerName: "Absolute Credit Limit",
      minWidth: 300,
      flex: 3,
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 100,
      type: "actions",
      getActions: (params) => {
        let arr = [
          <GridActionsCellItem
            icon={<Visibility />}
            label="View"
            onClick={() => handleViewClick(params.row)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit"
            onClick={() => handleEditClick(params.row)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<CreditCard />}
            label="Issue Credit"
            onClick={() => handleIssueCredit(params.row)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<NearMe />}
            label="Issue Charge"
            onClick={() => handleIssueCharge(params.row)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<LocalAtm />}
            label="Receive Payment"
            onClick={() => handlePaymentClick(params.row)}
            showInMenu
          />,
        ];

        if (params.row.type === "Company" && !isEmptyObject(params.row.contact)) {
          arr.push(
            <GridActionsCellItem
              icon={<Contacts />}
              onClick={() => handleEditCompanyContactClicked(params.row)}
              label="Edit Company Contact"
              showInMenu
            />,
          );
        }

        return arr;
      },
    },
  ];

  const columns1 = [
    {
      field: "name",
      headerName: "First Name",
      minWidth: 200,
      flex: 2,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      flex: 2,
      valueGetter: ({ row }) => {
        if (!isNullUndefined(row.email)) {
          return row.email;
        } else if (!isNullUndefined(row.contact)) {
          if (!isNullUndefined(row.contact && row.contact.email)) {
            return row.contact && row.contact.email;
          }
        } else {
          return "";
        }
      },
    },
    {
      field: "mobilePhone",
      headerName: "Phone Number",
      minWidth: 200,
      flex: 2,
      valueGetter: ({ row }) => {
        if (!isNullUndefined(row.mobilePhone)) {
          return row.mobilePhone;
        } else if (!isNullUndefined(row.contact)) {
          if (!isNullUndefined(row.contact && row.contact.mobilePhone)) {
            return row.contact && row.contact.mobilePhone;
          }
        } else {
          return "";
        }
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 100,
      type: "actions",
      getActions: (params) => {
        let arr = [];
        if (user.proxyRole === "BLDIR") {
          arr.push(
            <GridActionsCellItem
              icon={<Edit />}
              label="Edit"
              onClick={() => handleEditClick(params.row)}
              showInMenu
            />,
          );
        }
        if (
          user.proxyRole === "BLDIR" ||
          user.proxyRole === "BLDMG" ||
          user.proxyRole === "CS"
        ) {
          arr.push(
            <GridActionsCellItem
              icon={<Visibility />}
              label="View"
              onClick={() => handleViewClient(params.row)}
              showInMenu
            />,
          );
        }

        if (params.row.type === "Company" && !isEmptyObject(params.row.contact)) {
          arr.push(
            <GridActionsCellItem
              icon={<Contacts />}
              onClick={() => handleEditCompanyContactClicked(params.row)}
              label="Edit Company Contact"
              showInMenu
            />,
          );
        }

        return arr;
      },
    },
  ];

  function handleVoidClick(item) {
    if (item.type === "Charge" || item.type === "Invoice") {
      setCreditModal(true);
      //set the id of the transaction being voided
      setVoidItem(item);
    } else if (item.type === "Receipt" || item.type === "Credit") {
      setChargeModal(true);
      setVoidItem(item);
    }
  }

  const handleCreditClose = () => {
    setVoidItem(null);
    setCreditModal(false);
    setLoading(true);
    if (user.services.includes("MAINT")) {
      getFacilityCustomers()
        .then((rows) => setFacilityClients(rows || []))
        .catch(() => setFacilityClients([]))
        .finally(() => {
          setLoading(false);
        });
    } else {
      getCustomers()
        .then((rows) => setRows(rows || []))
        .catch(() => setRows([]))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleChargeClose = () => {
    setVoidItem(null);
    setChargeModal(false);
    setLoading(true);
    if (user.services.includes("MAINT")) {
      getFacilityCustomers()
        .then((rows) => setFacilityClients(rows || []))
        .catch(() => setFacilityClients([]))
        .finally(() => {
          setLoading(false);
        });
    } else {
      getCustomers()
        .then((rows) => setRows(rows || []))
        .catch(() => setRows([]))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Permit
      roles="BLDIR,BLDMG,CS"
      services="BLWTR,MAINT"
      noPermittedServiceMessage={{
        title: "Access Denied",
        body: (
          <>
            Your current role and/or facility is not permitted to view this
            page. <br /> Please contact your system admin if you feel this is an
            error.
          </>
        ),
      }}
    >
      <MainContainer>
        {!ViewDiv && (
          <TopBarContainer container width={{ xs: "100%", lg: "80%" }}>
            <Grid item sx={{ width: { xs: "100%", lg: "50%" } }}>
              <Typography
                variant="h5"
                sx={{
                  margin: "auto 0",
                  textAlign: { xs: "center", lg: "start" },
                }}
              >
                Customers Page
              </Typography>
            </Grid>
            <Grid
              item
              sx={{ width: { xs: "100%", lg: "50%" }, textAlign: "end" }}
            >
              <Permit roles={"BLDIR"}>
                <TopBarContainedBrandButton
                  variant="contained"
                  type="submit"
                  onClick={() => setCustomerModal(true)}
                  sx={{
                    width: { xs: "100%", md: "200px" },
                  }}
                >
                  Add Customer
                </TopBarContainedBrandButton>
              </Permit>
            </Grid>
          </TopBarContainer>
        )}
        <br />

        {!ViewDiv && !user.services.includes("MAINT") && (
          <MuiDataGrid
            noSelection={true}
            dataGridColumns={columns}
            dataGridRows={rows}
            serverPagination={false}
            loading={loading}
            height="60vh"
            totalRows={rows.length}
          />
        )}

        {ViewDiv && (
          <CustomerView
            selectedCustomer={selectedCustomer}
            statementYear={statementYear}
            handleVoidClick={handleVoidClick}
            setViewDiv={setViewDiv}
            handlePrintCustomerStatement={handlePrintCustomerStatement}
            handleStatementYearChange={handleStatementYearChange}
          />
        )}

        <PersonOrgSearch
          contractType={"customer"}
          closeModal={() => setCustomerModal(false)}
          showPersonOrgModal={customerModal}
          handlePersonOrgClose={() => setCustomerModal(false)}
          handlePersonOrgSelect={handlePersonOrgSelect}
          showAddNewUserForm={handleNewIndividual}
          showAddNewOrgForm={handleNewCompany}
        />
        {(task === "Edit" || task === "Add") && AddUserModal && (
          <AddNewUser
            openModal={AddUserModal}
            closeModal={() => {
              setAddUserModal(false);
              setSelectedCustomer(null);
              setTask("");
            }}
            saveUser={
              user.services.includes("MAINT")
                ? addFacilityCustomer
                : addCustomer
            }
            selectedPerson={selectedCustomer}
            manageUsers={false}
            customer={!user.services.includes("MAINT")}
            task={task}
            billingPeriods={billingPeriods}
            meterBillingDays={meterBillingDays}
            allowEditUser={task === "Edit"}
          />
        )}
        {(task === "Edit" || task === "Add") && AddOrganizationModal && (
          <AddNewOrganization
            openModal={AddOrganizationModal}
            closeModal={() => {
              setAddOrganizationModal(false);
              setSelectedCustomer(null);
              setTask("");
            }}
            selectedOrg={selectedCustomer}
            handleSave={true}
            customer={!user.services.includes("MAINT")}
            task={task}
            saveOrg={
              user.services.includes("MAINT")
                ? addFacilityCustomer
                : addCustomer
            }
            searchedName={companySearch}
            billingPeriods={billingPeriods}
            meterBillingDays={meterBillingDays}
            allowEditContact={true}
            allowEditOrg={task === "Edit"}
          />
        )}
        {
          PaymentModal && (
              <ReceivePayment
                showPaymentModal={PaymentModal}
                handlePaymentClose={() => setPaymentModal(false)}
                paymentMode={"Customer"}
                contract={selectedCustomer}
                savePayment={savePayment}
              />
            )
        }

        {!ViewDiv && user.services.includes("MAINT") && (
          <MuiDataGrid
            noSelection={true}
            dataGridColumns={columns1}
            dataGridRows={facilityClients}
            serverPagination={false}
            loading={loading}
            height="60vh"
            totalRows={facilityClients.length}
          />
        )}

        {/*CREDIT MODAL*/}
        {creditModal && (
          <CreditNote
            open={creditModal}
            onClose={handleCreditClose}
            voiditem={voidItem}
            meterbillingid={selectedCustomer && selectedCustomer.billingId}
          />
        )}

        {/*CHARGE MODAL*/}
        {chargeModal && (
          <DebitNote
            open={chargeModal}
            onClose={handleChargeClose}
            voiditem={voidItem}
            meterbillingid={selectedCustomer && selectedCustomer.billingId}
          />
        )}

        <EditUserModal
          showAddNewUserForm={editCompanyContactModal}
          handleAddUserClose={() => {
            setEditCompanyContactModal(false);
            setSelectedCompanyContact();
            setTask("");
          }}
          selectedUser={selectedCompanyContact}
          setSelectedUser={(userUpdate) =>
            setSelectedCompanyContact(userUpdate)
          }
          handleSaveUserClicked={handleSaveCompanyContactClicked}
          idTypes={idTypes}
          userRoles={userRoles}
          isCompanyContact={true}
          task={task}
        />
      </MainContainer>
    </Permit>
  );
}
